import React from 'react';
import { Skeleton } from 'antd';
import './skeletons.css';

/**
 * TableSkeleton Component
 *
 * Displays a skeleton loading state for Ant Design tables.
 * Shows a structured placeholder with rows and columns while data is loading.
 *
 * @param {number} rows - Number of skeleton rows to display (default: 10)
 * @param {number} columns - Number of skeleton columns to display (default: 6)
 * @param {boolean} hasActions - Whether to show action column skeleton (default: true)
 */
const TableSkeleton = ({
  rows = 10,
  columns = 6,
  hasActions = true
}) => {
  return (
    <div className="table-skeleton-container">
      {/* Table Header Skeleton */}
      <div className="table-skeleton-header">
        {Array.from({ length: columns }).map((_, colIndex) => (
          <div key={`header-${colIndex}`} className="table-skeleton-header-cell">
            <Skeleton.Input active size="small" style={{ width: '80%' }} />
          </div>
        ))}
        {hasActions && (
          <div className="table-skeleton-header-cell">
            <Skeleton.Input active size="small" style={{ width: '60px' }} />
          </div>
        )}
      </div>

      {/* Table Body Skeleton */}
      <div className="table-skeleton-body">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={`row-${rowIndex}`} className="table-skeleton-row">
            {Array.from({ length: columns }).map((_, colIndex) => (
              <div key={`cell-${rowIndex}-${colIndex}`} className="table-skeleton-cell">
                <Skeleton.Input
                  active
                  size="small"
                  style={{
                    width: colIndex === 0 ? '40px' : '90%',
                    height: '20px'
                  }}
                />
              </div>
            ))}
            {hasActions && (
              <div className="table-skeleton-cell">
                <Skeleton.Button active size="small" shape="default" />
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Pagination Skeleton */}
      <div className="table-skeleton-pagination">
        <Skeleton.Button active size="small" style={{ width: '300px' }} />
      </div>
    </div>
  );
};

export default TableSkeleton;
